import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
} from '@mui/material';

interface SaveTemplateDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (templateName: string) => void;
    isSubmitting?: boolean;
}

export const SaveTemplateDialog: React.FC<SaveTemplateDialogProps> = ({ open, onClose, onSave, isSubmitting }) => {
    const [templateName, setTemplateName] = useState('');
    const [error, setError] = useState('');

    const handleSave = () => {
        if (!templateName.trim()) {
            setError('Template name is required');
            return;
        }
        onSave(templateName.trim());
        setTemplateName('');
        setError('');
    };

    const handleClose = () => {
        setTemplateName('');
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Save as Template</DialogTitle>
            <DialogContent>
                <Box sx={{ pt: 1 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Save the current offer configuration as a template for future use.
                    </Typography>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Template Name"
                        value={templateName}
                        onChange={(e) => {
                            setTemplateName(e.target.value);
                            setError('');
                        }}
                        error={!!error}
                        helperText={error}
                        placeholder="e.g., Premium 30 Days Template"
                        disabled={isSubmitting}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={handleClose} disabled={isSubmitting}>
                    Cancel
                </Button>
                <Button onClick={handleSave} variant="contained" disabled={isSubmitting}>
                    {isSubmitting ? 'Saving...' : 'Save Template'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveTemplateDialog;
